/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Aaf_Embed_LinkedInputs */



/**
* | output |
* | --- |
* | "AAF Embed (Linked MXF)" |
*
* @param {Subtitle_Export_Aaf_Embed_LinkedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_aaf_embed_linked = /** @type {((inputs?: Subtitle_Export_Aaf_Embed_LinkedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Aaf_Embed_LinkedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégration AAF (MXF lié)")
	if (locale === "de") return /** @type {LocalizedString} */ ("AAF-Einbettung (verknüpfte MXF-Datei)")
	if (locale === "it") return /** @type {LocalizedString} */ ("AAF Embed (MXF collegato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встраивание AAF (связанный MXF)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Integración de AAF (MXF vinculado)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AAF 嵌入（链接 MXF）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AAF埋め込み（リンクされたMXF）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एएएफ एम्बेड (लिंक्ड एमएक्सएफ)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporação AAF (MXF vinculado)")
	return /** @type {LocalizedString} */ ("AAF Embed (Linked MXF)")
});